var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerRed = function SvgMarkerRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 42,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#markerRed_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16 .663a16.96 16.96 0 0 0-8.524 3.545 17.3 17.3 0 0 0-5.467 7.514 17.5 17.5 0 0 0-.818 9.298 17.4 17.4 0 0 0 4.069 8.376L14 39.223a5.4 5.4 0 0 0 1.812 1.327 5.34 5.34 0 0 0 4.375 0A5.4 5.4 0 0 0 22 39.223l8.7-9.827a17.43 17.43 0 0 0 4.194-9.366c.43-3.48-.193-7.011-1.786-10.125a17.2 17.2 0 0 0-7.136-7.315A16.9 16.9 0 0 0 15.998.663m2 23.687a6.36 6.36 0 0 1-3.573-1.086 6.5 6.5 0 0 1-2.373-2.915 6.6 6.6 0 0 1-.373-3.76 6.53 6.53 0 0 1 1.752-3.335 6.4 6.4 0 0 1 3.287-1.786 6.34 6.34 0 0 1 3.712.367 6.44 6.44 0 0 1 2.884 2.395 6.57 6.57 0 0 1 1.084 3.616 6.55 6.55 0 0 1-1.874 4.592A6.38 6.38 0 0 1 18 24.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31412",
    d: "M18 24.533c3.734 0 6.76-3.067 6.76-6.85 0-3.781-3.026-6.848-6.76-6.848s-6.76 3.066-6.76 6.849c0 3.782 3.027 6.849 6.76 6.849"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31412",
    d: "M18 22.558c2.658 0 4.812-2.182 4.812-4.874s-2.154-4.875-4.811-4.875-4.812 2.183-4.812 4.875 2.155 4.874 4.812 4.874"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "markerRed_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v41.538H0z"
  })))));
};
export default SvgMarkerRed;